import React from 'react';
import { stats } from '../data/content';
export function StatStrip() {
  return <section aria-label="Key facts" className="w-full border-y border-ash-200 bg-white" data-id="element-202" data-mp="2aisdxveq9g89">
      <div className="mx-auto grid w-full max-w-7xl grid-cols-2 gap-px bg-ash-200 px-5 lg:grid-cols-4 lg:px-8" data-id="element-203" data-mp="25jfrvcvokd6q">
        {stats.map(stat => <div key={stat.label} className="flex flex-col gap-1 bg-white px-2 py-8 lg:px-6" data-id="element-204" data-mp="20jjmpab8yfpl">
            <span className="font-display text-4xl leading-none text-royal-600" data-id="element-205" data-mp="1vm9zm1bbyg4x">{stat.value}</span>
            <span className="text-sm leading-snug text-ash-500" data-id="element-206" data-mp="1qtguvdfv37su">{stat.label}</span>
          </div>)}
      </div>
    </section>;
}